import type { Fact } from '../facts';
import type { Rng } from '../rng';
import { nearMiss } from './choice4';

/** Исходы независимы, ограничений на серии нет. Любое ограничение делает
 *  очередной исход выводимым из предыдущих, а ребёнок замечает такие
 *  закономерности быстрее, чем кажется: точная квота «4 верных и 3 неверных»
 *  выдаёт последний исход в 42,9% сессий, запрет серий из четырёх — 59,4%.
 *  Независимый бросок не выдаёт ничего (раздел 5.5). */
export function truthSequence(count: number, rng: Rng): boolean[] {
  return Array.from({ length: count }, () => rng() < 0.5);
}

/** Предъявленное равенство. Неверное значение — соседняя строка той же
 *  таблицы: «9 × 9 = 18» решается по порядку величины без знания
 *  таблицы, «9 × 9 = 72» заставляет считать (раздел 5.5). */
export function presentedValue(fact: Fact, isTrue: boolean, rng: Rng): number {
  return isTrue ? fact.answer : nearMiss(fact, rng);
}
